import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ConfigService } from '@app/services';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs/operators';
import { ImageSchema } from '@app/schemas/image';
import { resolveImageUrl$ } from './image-url';

@Component({
  selector: 'app-image',
  templateUrl: './image.component.html',
  styleUrl: './image.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImageComponent {

  private readonly domSanitizer = inject(DomSanitizer);
  private readonly configService = inject(ConfigService);

  public readonly image = input.required<ImageSchema>();
  public readonly alt = input<string>();
  public readonly objectFit = input<string>();
  public readonly objectPosition = input<string>();

  public readonly url$ = resolveImageUrl$(
    toObservable(this.image).pipe(map((image) => image.uri)),
    this.configService.files$,
  );

  public readonly url = toSignal(this.url$, { initialValue: undefined });

  public readonly src = computed(() => {
    return this.url() ? this.domSanitizer.bypassSecurityTrustResourceUrl(this.url()!) : undefined;
  });

  public readonly width = computed(() => {
    return this.image().width;
  });

  public readonly height = computed(() => {
    return this.image().height;
  });

}
